/**
 * Domain Entity: HomePageData
 * Represents the home page data structure.
 * Since the exact structure is unknown, we'll use a flexible Record type
 * that can be extended later when the API response structure is known.
 */
export class HomePageData {
  data: Record<string, unknown>;

  constructor(data: Record<string, unknown>) {
    this.data = data;
  }
}

